import { useContext } from 'react';
import ThemeContext from '../../../../setup/themeContext';
import { useThemeMode } from 'setup/themeContextMaterial';
import { IconButton, Tooltip } from '@mui/material';
import LightModeRoundedIcon from '@mui/icons-material/LightModeRounded';
import DarkModeRoundedIcon from '@mui/icons-material/DarkModeRounded';

function ThemeBox() {
  const themeCtx = useContext(ThemeContext);
  const { toggleTheme, mode } = useThemeMode();
  const isDark = mode === 'dark';
  const label = isDark ? 'Switch to light mode' : 'Switch to dark mode';

  const handleToggle = () => {
    themeCtx.toggleTheme();
    toggleTheme();
  };

  return (
    <Tooltip title={label}>
      <IconButton onClick={handleToggle} aria-label={label} size="medium">
        {isDark ? <LightModeRoundedIcon /> : <DarkModeRoundedIcon />}
      </IconButton>
    </Tooltip>
  );
}

export default ThemeBox;
